import { useAuth } from "@/contexts/AuthContext";
import { useLanguage } from "@/contexts/LanguageContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { UserCircle } from "lucide-react";

export default function DealSourcerProfile() {
  const { user } = useAuth();
  const { language } = useLanguage();
  const lang = (language as "en" | "fr") || "en";
  return (
    <div className="space-y-4 max-w-2xl">
      <h1 className="text-2xl font-bold text-[#1D314D]">
        {lang === "fr" ? "Mon Profil" : "My Profile"}
      </h1>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <UserCircle className="h-5 w-5 text-[#CEAB65]" />
            {user?.displayName || user?.email}
          </CardTitle>
        </CardHeader>
        <CardContent className="text-muted-foreground text-sm">
          {lang === "fr" ? "Profil Deal Sourcer — mise à jour bientôt disponible." : "Deal Sourcer Profile — update coming soon."}
        </CardContent>
      </Card>
    </div>
  );
}